import { useContext, useRef, useMemo } from "react";
import { AppContext } from "../contexts";
import { getLocale } from "../utils";

export default function useTranslation() {
  const { labels = {} } = useContext(AppContext);
  const { current: { locale, region } } = useRef(getLocale());
  const localeObject = useMemo(() => labels[`${locale}-${region}`] || labels[locale] || labels, [labels, locale, region]);

  const i18n = (string, replacers = {}) => {
    let label = localeObject[string];
    if (!(string in localeObject)) {
      // Fall back to top-level (default) labels when the locale labels lack the key
      label = typeof labels[string] === 'string' && labels[string];
      if (!label) return string;
    } else if (label === '') {
      return '';
    } else if (!label) {
      return string;
    }

    Object.keys(replacers).forEach(k => {
      label = label.replace(`{${k}}`, replacers[k]);
    })

    return label;
  };

  return { i18n };
}
